var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "active font-outfit-medium" },
    [
      _c(
        "ib-tooltip",
        {
          attrs: {
            content: `${_vm.$t("pages.pricing.featuresTexts.aiRequests")}`,
            dark: !_vm.dark,
          },
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.numOfRequests) +
                " " +
                _vm._s(_vm.$t("pages.pricing.featuresName.aiRequests")) +
                " "
            ),
            _c("img", {
              attrs: {
                src: require("@/assets/img/illustrations/payment/ai-requests-icon.svg"),
                alt: "ai-requests",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }